import React from 'react'
import styled, { keyframes } from 'styled-components'
import theme from '../../styles/theme'

const rotateAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

export const InlineSpinnerWrapper = styled.div`
  display: inline-flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 1em;
  height: 1em;
  div {
    display: block;
    position: absolute;
    border: 1px solid ${({ color }) => color};
    border-radius: 50%;
    animation: ${rotateAnimation} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${({ color }) => color} transparent transparent transparent;
    width: 1em;
    height: 1em;
  }
  div:nth-child(1) {
    animation-delay: -0.45s;
  }
  div:nth-child(2) {
    animation-delay: -0.3s;
  }
  div:nth-child(3) {
    animation-delay: -0.15s;
  }
`

InlineSpinnerWrapper.defaultProps = {
  color: theme.brand.forest,
}

export default (props) => (
  <InlineSpinnerWrapper {...props}>
    <div />
    <div />
    <div />
    <div />
  </InlineSpinnerWrapper>
)
